<template>
	<div class="article-sidebar">
		<div class="article-sidebar__main">
			<div class="article-sidebar__header">
				<HmLogo :to="{ name: 'index' }" />
			</div>
			<div class="article-sidebar__body">
				<ArticleAppSwitcher />
				<ArticleNavigation />
			</div>
			<div class="article-sidebar__footer">
				<HmCopyright has-help />
			</div>
		</div>
	</div>
</template>

<style lang="scss">
@layer components
{
	.article-sidebar
	{
		display:none;

		@include responsive(lg)
		{
			@include flex;
			height:100dvh;
			padding:$spacing-sm;
			overflow-y:auto;
			overscroll-behavior:contain;
			-webkit-overflow-scrolling:touch;
			position:sticky;
			inset-block-start:0;
		}

		&__main
		{
			@include flex(null, null, 40);
			flex-direction:column;
			width:100%;
			padding-inline:$spacing-md;
		}
		&__header
		{
			@include flex(center, start);
			flex-direction:column;
			min-height:8rem;

			.logo
			{
				@include size(146, 40);
			}
		}
		&__body
		{
			flex-grow:1;
		}
		&__footer
		{
			padding-block:$spacing-md;
		}
	}
}
</style>
